/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { CamelCaseNamingConvention, MappingProfile, addProfile, createMap, namingConventions } from '@automapper/core';
import { mapper } from './app/tools/mapping/mapper';
import { Configuration } from './app/domain/configuration';
import { ConfigurationDTO } from './app/services/dto/configuration.dto';
import { ELIMSSample } from './app/domain/ELIMS/ELIMS-sample';
import { ELIMSSampleDTO } from './app/services/dto/ELIMS/elims-sample.dto';
import { ELIMSProductDTO } from './app/services/dto/ELIMS/elims-product.dto';
import { ELIMSProduct } from './app/domain/ELIMS/ELIMS-Product';
import { ELIMSTest } from './app/domain/ELIMS/ELIMS-test';
import { ClientDTO } from './app/services/dto/client.dto';
import { Client } from './app/domain/client';
import { ContractDTO } from './app/services/dto/contract.dto';
import { Contract } from './app/domain/contract';
import { LimitDTO } from './app/services/dto/limit.dto';
import { Limit } from './app/domain/limit';
import { LimitCategoryDTO } from './app/services/dto/limit-category.dto';
import { LimitCategory } from './app/domain/limit-category';
import { ProductGroupDTO } from './app/services/dto/product-group.dto';
import { ProductGroup } from './app/domain/product-group';
import { TestGroupDTO } from './app/services/dto/test-group.dto';
import { TestGroup } from './app/domain/test-group';
import { TestDTO } from './app/services/dto/test.dto';
import { Test } from './app/domain/test';
import { UserDTO } from './app/services/dto/user.dto';
import { User } from './app/domain/user';
import { ELIMSTestDTO } from './app/services/dto/ELIMS/elims-test.dto';

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));

const dtoProfile: MappingProfile = (mapper) => {
    createMap(mapper, ConfigurationDTO, Configuration)

    createMap(mapper, ELIMSSampleDTO, ELIMSSample)
    createMap(mapper, ELIMSProductDTO, ELIMSProduct)
    createMap(mapper, ELIMSTestDTO, ELIMSTest)

    createMap(mapper, ClientDTO, Client)
    createMap(mapper, ContractDTO, Contract)
    createMap(mapper, LimitDTO, Limit)
    createMap(mapper, LimitCategoryDTO, LimitCategory)

    createMap(mapper, ProductGroupDTO, ProductGroup)
    createMap(mapper, TestGroupDTO, TestGroup)
    createMap(mapper, TestDTO, Test)

    createMap(mapper, UserDTO, User)
}

addProfile(
    mapper,
    dtoProfile,
    namingConventions(new CamelCaseNamingConvention())
);